import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody } from "reactstrap";
import { httpGet, httpPUT, httpUpload } from "../../../../src/common/petitions";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Dropzone from "react-dropzone";
import { useNavigate } from 'react-router-dom';
import "../tables.scss";
import "../Puestos.scss";
import Model from "./model.json";

const TarifasConfigs = () => {
  const [data, setData] = useState(null);
  const [unidades, setUnidades] = useState([]);
  const [uploadResult, setUploadResult] = useState(null);
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);
  const [checkboxState, setCheckboxState] = useState({});

  const fetchData = async () => {
    try {
      const rowsData = await httpGet("/tarifas/configs/20232024", navigate);
      setUnidades(rowsData);
      // console.log(rowsData);
      const initialState = rowsData.reduce((acc, item, index) => {
        // console.log(item.idunique);
        Object.keys(item).forEach((key) => {
          if (key.startsWith('q_')) {
            acc[`${key}-${item.idunique}`] = JSON.parse(item[key]);
          }
        });
        return acc;
      }, {});
      console.log(initialState);
      setCheckboxState(initialState);

      const jsonData = {
        columns: Model.base,
        rows: addCheckboxesToRows(rowsData, initialState),
      };

      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (unidades.length > 0) {
      const updatedRows = addCheckboxesToRows(unidades, checkboxState);
      setData(prevData => ({
        ...prevData,
        rows: updatedRows,
      }));
    }
  }, [checkboxState]);

  const handleCheckboxChange = async (keyrow,valor) => {
    setCheckboxState(prevState => {
      const newState = { ...prevState };
      console.log(prevState[keyrow]);
      newState[keyrow] = !prevState[keyrow];
      return newState;
    });
    const [columna,idunique] = keyrow.split("-");
    // console.log(columna,idunique);
    const valorStr = valor.toString();
    console.log(valorStr);
    const datasend = {
      columna,
      idunique,
      valor:valorStr
    }
    
    // console.log(datasend,keyrow);
    try {
      const response = await httpPUT('/tarifas/configs', datasend, navigate);
      if (response.ok) {
        const result = await response.json();
        console.log('Update successful:', result);
      } else {
        console.error('Failed to update:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating item:', error.message);
    }
  };


  const addCheckboxesToRows = (rowsData, currentCheckboxState) => {
    return rowsData.map((row, index) => {
      const newRow = {};
      // console.log(`${index}-${row.idunique}`);
      Object.entries(row).forEach(([key, value]) => {
        if (key.startsWith("q_")) {
          newRow[key] = (
            <div key={`${key}-${row.idunique}`}>
              <input
                type="checkbox"
                id={`${key}-${row.idunique}`}
                checked={currentCheckboxState[`${key}-${row.idunique}`] || false}
                onChange={() => handleCheckboxChange(`${key}-${row.idunique}`,!currentCheckboxState[`${key}-${row.idunique}`] )}
              />
            </div>
          );
        }else{
          newRow[key] = value;
        }
      });
      return newRow;
    });
  };

  const uploadFile = async (file) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await httpUpload(`/tarifas/import`, formData, navigate);
      setUploadResult(response);
      // if (response.status === 200) {
      //   navigate('/mod/puestos');
      // }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };

  document.title = "Tarifas - Configuracion - IPG";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Tarifas" title="Configuracion" />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Dropzone onDrop={handleAcceptedFiles}>
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone-container">
                        <div className="btn btn-success dropzone me-5" {...getRootProps()}>
                          <input {...getInputProps()} />
                          <span>Subir configuraciones</span>
                        </div>
                        {isUploading && <div className="upload-loader">Uploading...</div>}
                        {uploadResult && (
                          <div className="upload-check">
                            <i className="bx bx-check-circle"></i>
                          </div>
                        )}
                      </div>
                    )}
                  </Dropzone>
                  {data && <MDBDataTable responsive striped bordered noBottomColumns data={data} style={{ 'fontSize': '12px' }} />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TarifasConfigs;
